/* eslint-disable react/require-default-props,react/no-unused-prop-types */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classnames from 'classnames';
import { Link } from '../../../Link/index';

import { ROUTE_USER_PROFILE_PAGE } from '../../../../../ReduxStorage/routeActions';

import { PROFILE_PAGE_PORTFOLIO, PROFILE_PAGE_COMMUNITIES } from '../../consts';

/* global _OL_ORIGIN */

export class ProfileHeaderStats extends PureComponent {
  static propTypes = {
    user: ImmutablePropTypes.map,
    hasEditAccess: PropTypes.bool,
  };

  onLocationClick = () => {
    window.open(`${_OL_ORIGIN}/accounts/account-settings/`, '_blank');
  };

  render() {
    const { user } = this.props;

    return (
      <ul className="stats">
        <li className="stat">
          <Link
            className="stat-link"
            to={{
              type: ROUTE_USER_PROFILE_PAGE,
              params: {
                page: PROFILE_PAGE_COMMUNITIES,
                profileName: user.get('profileName'),
              },
            }}
          >
            <span className="stat-value">
              {user.get('fans') ? user.get('fans').size : null}
            </span>{' '}
            <span className="stat-label">Fans</span>
          </Link>
        </li>
        <li className="stat">
          <Link
            className="stat-link"
            to={{
              type: ROUTE_USER_PROFILE_PAGE,
              params: {
                page: PROFILE_PAGE_PORTFOLIO,
                profileName: user.get('profileName'),
              },
            }}
          >
            <span className="stat-value">{user.getIn(['kudos', 'total'])}</span>{' '}
            <span className="stat-label">Kudos</span>
          </Link>
        </li>
        <li className="stat">
          <Link
            className="stat-link"
            to={{
              type: ROUTE_USER_PROFILE_PAGE,
              params: {
                page: PROFILE_PAGE_COMMUNITIES,
                profileName: user.get('profileName'),
              },
            }}
          >
            <span className="stat-value">{user.get('numOfCommunities')}</span>{' '}
            <span className="stat-label">Communities</span>
          </Link>
        </li>
      </ul>
    );
  }
}

export class ProfileHeaderStatsLoading extends PureComponent {
  render() {
    return (
      <ul className="stats">
        <li className={classnames('stat', 'skeleton-loading')} />
        <li className={classnames('stat', 'skeleton-loading')} />
        <li className={classnames('stat', 'skeleton-loading')} />
      </ul>
    );
  }
}
